import React, { useEffect, useState } from 'react';
import { Button, Card, Result, Spin, Typography, Alert } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, MailOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../services/authService';

const { Paragraph, Text } = Typography;

const CompleteRegistration: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [credits, setCredits] = useState<number | null>(null);

  useEffect(() => {
    const complete = async () => {
      try {
        setLoading(true);
        setError(null);

        const hashParams = new URLSearchParams(window.location.hash.replace('#', ''));
        const queryParams = new URLSearchParams(window.location.search);
        const accessToken = hashParams.get('access_token') || queryParams.get('access_token');
        const refreshToken = hashParams.get('refresh_token') || queryParams.get('refresh_token') || undefined;

        if (!accessToken) {
          throw new Error('Doğrulama tokenı bulunamadı. Lütfen emaildeki doğrulama linkini tekrar açın.');
        }

        const result = await AuthService.completeBrandRegistration(accessToken, refreshToken);
        setCredits(result.credits?.availableCredits ?? 20);
        setSuccess(true);
        window.history.replaceState(null, '', window.location.pathname);
      } catch (err: any) {
        setError(err.message || 'Kayıt tamamlanamadı');
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    complete();
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: 20 }}>
      <Card style={{ width: 560, boxShadow: '0 10px 40px rgba(0,0,0,0.1)', borderRadius: 16 }}>
        {loading && (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <Spin size="large" />
            <Paragraph style={{ marginTop: 16 }}>Email doğrulamanız kontrol ediliyor ve marka hesabınız aktifleştiriliyor...</Paragraph>
          </div>
        )}

        {!loading && success && (
          <Result
            icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
            title="Kayıt Tamamlandı"
            subTitle={
              <div>
                <Paragraph>Markanız aktifleştirildi.</Paragraph>
                <Alert type="success" showIcon message={`${credits ?? 20} kredi hesabınıza tanımlandı`} description="Artık Dashboard ve Studio özelliklerini kullanabilirsiniz." />
              </div>
            }
            extra={[
              <Button type="primary" key="dashboard" onClick={() => navigate('/dashboard')}>Dashboard'a Git</Button>,
            ]}
          />
        )}

        {!loading && !success && (
          <Result
            icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
            title="Kayıt Tamamlanamadı"
            subTitle={
              <div>
                <Paragraph>{error}</Paragraph>
                <Text type="secondary"><MailOutlined /> Linkin süresi dolduysa kayıt ekranından tekrar deneyin.</Text>
              </div>
            }
            extra={[
              <Button key="register" onClick={() => navigate('/register')}>Kayıt Sayfasına Dön</Button>,
              <Button type="primary" key="login" onClick={() => navigate('/login')}>Giriş Sayfası</Button>,
            ]}
          />
        )}
      </Card>
    </div>
  );
};

export default CompleteRegistration;
